module.exports = __webpack_public_path__ + "static/logistics-collect-goods@2x-5a3f1e1ff49efa4fb7217506265f1499.png";